export default {
  width: 31,
  height: 24,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 3.45a1 1 0 0 0-1.66-.74l-5.1 4.53a3 3 0 0 1-2 .76H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6.24a3 3 0 0 1 2 .76l5.1 4.53a1 1 0 0 0 1.66-.74V3.45zm-3-2.24a3 3 0 0 1 5 2.24v17.1a3 3 0 0 1-5 2.24l-5.1-4.54a1 1 0 0 0-.66-.25H3a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3h6.24a1 1 0 0 0 .66-.25L15 1.2zM28.86 3.49a1 1 0 0 1-.35 1.37l-5 3a1 1 0 1 1-1.02-1.72l5-3a1 1 0 0 1 1.37.35zM23 12a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1zm-.86 4.49a1 1 0 0 1 1.37-.35l5 3a1 1 0 1 1-1.02 1.72l-5-3a1 1 0 0 1-.35-1.37z"/>
  `
}
